export default "__VITE_ASSET__vqksCPVG__";